Alerts = require 'views/lib/alerts'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class MemberDeleteConfirmView extends View
  viewTitleKey: 'delete account'

  events:
    'click .js-delete-member': 'deleteMember'
    'click .js-cancel-delete': 'cancelDeleteMember'

  render: ->
    view = @

    @$el.html(
      templates.fill('popover_confirm_member_delete', @model.toJSON())
    )

    @

  deleteMember: (e) ->
    Util.stop(e)
    @$('.js-delete-member').attr('disabled', 'disabled')

    @model.run 'deleteAccount', { msg: "troodbye!" }, ->
      PopOver.hide()
      Alerts.flash('email sent', 'confirm')
      track("Member", "Sent Account Delete Email")
      return

    return

  cancelDeleteMember: (e) ->
    Util.stop(e)
    PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-delete-confirm-view.coffee